var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.433 23.587a12.508 12.508 0 0 0 3.07-5.005.046.046 0 0 0-.022 0 13.804 13.804 0 0 1-11.933-3.88 13.804 13.804 0 0 1-3.88-11.933.048.048 0 0 0 0-.021 12.51 12.51 0 0 0-5.005 3.069c-4.907 4.907-4.907 12.863 0 17.77s12.863 4.907 17.77 0zm4.275-4.65a13.765 13.765 0 0 1-3.386 5.538c-5.398 5.398-14.15 5.398-19.547 0-5.398-5.398-5.398-14.15 0-19.547a13.765 13.765 0 0 1 5.538-3.386c.966-.31 1.73.578 1.597 1.422a12.547 12.547 0 0 0 3.527 10.85 12.547 12.547 0 0 0 10.849 3.526c.843-.133 1.732.631 1.422 1.597l-.598-.192.598.192z",
    fill: "#001F55",
    stroke: "#062A6A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseNight);
export default __webpack_public_path__ + "static/media/CourseNight.591dd062e0dce06c8bdf34d28da53696.svg";
export { ForwardRef as ReactComponent };